import React from "react";

const ArrowDown = props => (
  <svg viewBox="0 0 26 16" {...props}>
    <path
      d="M1.439 1.04l10.13 13.38c.277.39.714.627 1.184.643.47.016.921-.192 1.223-.562L24.528.932"
      stroke="currentColor"
      strokeWidth={1.92}
      fill="none"
      fillRule="evenodd"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

export default ArrowDown;
